import { useQuery } from "@tanstack/react-query";
import dateFormat from "dateformat";
import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";

const WorkPortfolio = () => {
  const { id } = useParams();
  const { data, isLoading } = useQuery(["portfolio"], async () => {
    const response = await window.fetch(`${BASE_URL}/project-details/${id}`);
    return await response.json();
  });

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Helmet>
        <title>AFRO || Portfolio</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="" staticImageURL="">
        <div className="pt-7 pb-7 text-center">
          <h1 className="fs-56 gilroy-bold text-center text-white">
            Work Portfolio
          </h1>
        </div>
      </Header>
      <section className="container-fluid pt-7 pb-13">
        <div className="ms-35 me-35">
          <article>
            <div className="h-100 blog-card">
              <div className="card-body blog-card-body-padding fs-20">
                <div className="position-relative">
                  <img
                    src={`${IMAGE_BASE_URL}/${data?.project?.image}`}
                    style={{ height: "35rem" }}
                    className="card-img-top w-full d-block"
                    loading="lazy"
                    alt="..."
                  />
                  <p className="blog-img-text fs-16 bg-american-yellow text-white fw-700">
                    {data?.project?.region?.name}
                  </p>
                </div>

                <h2 className="fs-56 lh-56 gilroy-bold pt-5">
                  {data?.project?.title}
                </h2>
                <h3 className="fs-28 lh-40 gilroy-bold pt-3">
                  {data?.project?.client_name}
                </h3>

                <div>
                  <p className="text-orange-ryb gilroy-bold fs-20">
                    Delivery Date:
                  </p>
                  <p className="text-dark fs-14">
                    {dateFormat(data?.project?.end_date, "dS mmmm, yyyy")}
                  </p>
                  <p className="text-orange-ryb gilroy-bold fs-20">
                    Location:{" "}
                  </p>
                  <p className="text-dark fs-14">{data?.project?.location}</p>
                </div>
                <h3 className="text-orange-ryb gilroy-bold fs-20">
                  Description
                </h3>
                <p
                  className="fs-16 lh-30"
                  dangerouslySetInnerHTML={{
                    __html: data?.project?.description,
                  }}
                />
                <h3 className="text-orange-ryb gilroy-bold fs-20">
                  Key Achievements
                </h3>
                <p
                  className="fs-16 lh-30"
                  dangerouslySetInnerHTML={{
                    __html: data?.project?.key_achievement,
                  }}
                />
              </div>
            </div>
          </article>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default WorkPortfolio;
